import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { merge, Observable, throwError, BehaviorSubject, forkJoin, of } from 'rxjs';
import { catchError, retry, map, tap, mergeMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { FlightSchedulesNew, FlightSearchNewResponseProperties, MulticityResponseFlightsNew } from '../Models/flight-results-response-properties';

import { concatMap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class GetFlightResultsService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  AirIndiaFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirIndia', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  GetFlightResultAirArabiaOneApiNew(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaOneApi', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  GetMultiCityFlightResultAirArabiaOneApiNew(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaOneApiMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiCityFlightResultAirArabiaTushmitOneApi(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiCityFlightResultAirArabiaTushmitOneApi', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiCityFlightResultAirArabiaPakistanOneApiNew(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiCityFlightResultAirArabiaPakistanOneApiNew', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirArabiaPakistanOneApiNew(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaPakistanOneApi', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirBlue(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlue', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirBlueT4Travels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueT4Travels', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  AirBlueMulticityFlightResult(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  AirBlueMulticityFlightResultT4Travels(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueMultiT4Travels', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  AljazeeraFlightT4TRVLS(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/AljazeeraFlightT4TRVLS', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  AljazeeraFlightT4TRVLSBSP(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/AljazeeraFlightT4TRVLSBSP', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  AljazeeraFlightOKAPI(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/AljazeeraFlightOKAPI', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  AljazeeraFlightOKAPIBSP(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/AljazeeraFlightOKAPIBSP', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGalileo(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultGalileo', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGalileo1WS(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultGalileo1WS', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGalileo8X4I(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultGalileo8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }


  GetFlightsResultGalileoB2D(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultGalileoB2D', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGalileo82QT(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultGalileo82QT', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  RepriceFlightGalileo(airPricingSolution): Observable<FlightSearchNewResponseProperties> {
    this.showSpinner.next(true);
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/RepriceGalileoFlight', airPricingSolution, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }

  ChangeRBDGalileo(airPricingSolution): Observable<FlightSearchNewResponseProperties> {
    this.showSpinner.next(true);
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/ChangeGalileoRBD', airPricingSolution, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  GetFlightsResultSabre(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultSabre', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  //commented because we are using OneAPI to get results for AirArabia, no independent call needed
  //AirArabiaFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
  //  return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabia', FlightSearchObj, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      ////Console.log(data);
  //      return data;
  //    }),
  //      catchError(error => { return throwError(error); }))
  //}
  //AirArabia3LFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
  //  return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabia3L', FlightSearchObj, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      ////Console.log(data);
  //      return data;
  //    }),
  //      catchError(error => { return throwError(error); }))
  //}
  PIAFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultPIA', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  PIAMulticityFlightResult(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultPIAMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirArabiaMulti(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirArabiaMultiPakistan(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaMultiPakistan', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirArabiaMulti3L(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaMulti3L', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirArabia3LMultiPakistan(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabia3LMultiPakistan', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGalileo8K5X(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultGalileo8K5X', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGalileo7KE2(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultGalileo7KE2', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiFlightsResultGalileo(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResultGalileo', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  GetMultiFlightsResultGalileo8X4I(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResultGalileo8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiFlightsResultGalileoB2D(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResultGalileoB2D', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiFlightsResultGalileo82QT(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResultGalileo82QT', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  GetMultiFlightsResultGalileo8K5X(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResultGalileo8K5X', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiFlightsResultGalileo7KE2(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResultGalileo7KE2', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  AirArabiaFlightsResultPakistan(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaPakistan', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  AirArabia3LFlightsResultPakistan(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabia3LPakistan', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  //commented because we are using OneAPI to get results for AirArabia, no independent call needed
  //FlyJinnahFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
  //  return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultFlyJinnah', FlightSearchObj, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      ////Console.log(data);
  //      return data;
  //    }),
  //      catchError(error => { return throwError(error); }))
  //}
  SpiceFlightResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/SpiceFlightResult', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  AirSialFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/AirSialFlightResults', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  FlyDubaiFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/FlyDubaiFlightResults', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  FlyDubaiFlightResultsTushmit(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/FlyDubaiFlightResultsTushmit', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  FitsAirFlightResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/FitsAirFlightResults', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  USBanglaFlightsResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/USBanglaGetFlightAvailbility', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultEmiratesT4travels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultEmiratesT4travels', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultEmiratesT4travelsMulti(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultEmiratesT4travelsMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }


  GetFlightResultEmiratesTUtravels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultEmiratesTUtravels', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultEmiratesTUtravelsMulti(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultEmiratesTUtravelsMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  //sabre R0AL
  GetFlightsResultSabreR0AL(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultSabreR0AL', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  //sabre

    //sabre R0AL
    GetFlightsResultSabreNew(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
      return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResultSabreNew', FlightSearchObj, this.httpOptions)
        .pipe(map((data: any) => {
          return data;
        }),
          catchError(error => { return throwError(error); }))
    }
    //sabre
  // GetFlightCalendarResult(FlightSearchObj): Observable<AdvCalendarSearchResponse> {
  //   return this.http.post<AdvCalendarSearchResponse>(this.baseUrl + '/FlightSearch/GetFlightsCalendarResultSabre', FlightSearchObj, this.httpOptions)
  //     .pipe(map((Advdata: AdvCalendarSearchResponse) => {
  //       return Advdata;
  //     }),
  //       catchError(error => { return throwError(error); }))
  // }

  // GetRBDforCabin(airPricingSolution): Observable<ChangeRBDParamsGalileo> {
  //   return this.http.post<ChangeRBDParamsGalileo>(this.baseUrl + '/FlightSearch/GetRBDCodesForCabin', airPricingSolution, this.httpOptions)
  //     .pipe(map((Advdata: ChangeRBDParamsGalileo) => {
  //       return Advdata;
  //     }),
  //       catchError(error => { return throwError(error); }))
  // }


  //Indigo6E
  GetFlightsResult6E(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResult6E', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResult6E8X4I(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightsResult6E8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiFlightsResult6E(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResult6E', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiFlightsResult6E8X4I(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResult6E8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetGroupFlightResultNew(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetGroupFlightResultNew', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetGroupFlightResult(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetGroupFlightResult', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetRBDsForChangeBooking(FlightSearchObj): Observable<FlightSchedulesNew> {
    return this.http.post<FlightSchedulesNew>(this.baseUrl + '/FlightSearch/GetRBDsForChangeBooking', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  GetFlightResultAirIndiaModify(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/ModifyFlightResultAirIndia', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightSearchResultFTOktravels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightSearchFTOKTravel', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  //SereneAir flight Search service - commented because this flight is no longer availavle to book flights
  //GetFlightResultSereneAir(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
  //  return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultSerene', FlightSearchObj, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      return data;
  //    }),
  //      catchError(error => { return throwError(error); }))
  //}

  GetFlightSearchResultAkasaOkTravel(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightSearchAkasaAir', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightSearchResultOVOktravels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightSearchOVOKTravel', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGDS8X4I(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultGDS8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGDS1WS(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultGDS1WS', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultNDC1WS(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultNDC1WS', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultNDC8X4I(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultNDC8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        ////Console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityGDS8X4I(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityGDS8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityNDC8X4I(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityNDC8X4I', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  FlyDubaiMulticityFlightResult(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/FlyDubaiFlightResultsMultiCity', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  FlyDubaiTushmitMulticityFlightResult(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/FlyDubaiFlightResultsMultiCityTushmit', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightSearchResultFlynas(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightSearchFlynas', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetMultiFlightsResultFlynas(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/MultiCityFlightSearchFlynas', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGDS7KE2(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultGDS7KE2', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultNDC7KE2(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultNDC7KE2', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityGDS7KE2(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityGDS7KE2', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityNDC7KE2(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityNDC7KE2', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  GetMultiFlightsResultSharaf(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetMultiFlightsResultSharaf', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  GetFlightsResultGDS8K5X(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultGDS8K5X', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultNDC8K5X(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultNDC8K5X', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityGDS8K5X(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityGDS8K5X', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityNDC8K5X(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityNDC8K5X', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultGDSB2D(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultGDSB2D', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultNDCB2D(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/TravelPort/GetFlightsResultNDCB2D', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        console.log(data);
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityGDSB2D(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityGDSB2D', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightsResultMultiCityNDCB2D(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/TravelPort/GetFlightsResultMultiCityNDCB2D', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirArabiaTushmitOneApi(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirArabiaTushmitOneApi', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultSharafTravel(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightSearchSharaf', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  GetFlightResultAirBlueTUTravels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueTUTravels', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirBlueSastaTravels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueSastaTravels', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirBlueDoTravels(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueDoTravels', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirBlueTUTravelsMulti(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueTUTravelsMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirBlueSastaTravelsMulti(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueSastaTravelsMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightResultAirBlueDoTravelsMulti(FlightSearchObj ): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetFlightResultAirBlueDoTravelsMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  AljazeeraFlightMultiT4TRVLSBSP(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/AljazeeraFlightMultiT4TRVLSBSP', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  AljazeeraFlightMultiT4TRVLS(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/AljazeeraFlightMultiT4TRVLS', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  AljazeeraFlightMultiOKAPI(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/AljazeeraFlightMultiOKAPI', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  AljazeeraFlightMultiOKAPIBSP(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/AljazeeraFlightMultiOKAPIBSP', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  GetPIANDCFlightSearch(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetPIANDCFlightSearch', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetTurkishAirlinesFlightSearch(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetTKNDCFlightSearch', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlyAdealFlightResults(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlyAdealFlightResults', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetPIANDCFlightSearchMulti(FlightSearchObj): Observable<MulticityResponseFlightsNew> {
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/GetPIANDCFlightSearchMulti', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightSearchResultAirSial(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/AirSialFlightResults', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
  GetFlightSearchResultAirSialTushmitId(FlightSearchObj): Observable<FlightSearchNewResponseProperties> {
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/AirSialFlightResultsTushmitId', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
}
